export default __webpack_public_path__ + "static/media/right.2fa4de5d.svg";